<template>
  <Header />
  <div class="legal-page">
    <main class="legal-content">
      <div class="legal-container">
        <header class="legal-header">
          <h1 class="legal-title">Cookie Policy</h1>
          <h2 class="legal-updated">Ultimo aggiornamento: 16 gennaio 2026</h2>
          <div>
            Questa Cookie Policy descrive l’uso dei cookie sul nostro sito. 
            Il sito utilizza esclusivamente cookie necessari alla gestione del consenso e cookie analitici di Google Analytics 4, 
            attivati solo dopo il consenso esplicito dell’utente.
          </div>
        </header>

        <section class="legal-section">
          <h2>Cosa sono i cookie</h2>
          <div>
            I cookie sono piccoli file di testo che i siti web salvano sul dispositivo dell'utente
            per ricordare preferenze, scelte o informazioni tecniche. Alcuni cookie sono essenziali
            al funzionamento del sito, altri servono a raccogliere dati statistici.
          </div>
        </section>

        <section class="legal-section">
          <h2>Come usiamo i cookie sul nostro sito</h2>
          <div>
            Su sportemocracy.it utilizziamo esclusivamente cookie necessari per memorizzare la scelta di consenso e cookie analitici di Google Analytics 4. 
            Non utilizziamo cookie di marketing, profilazione o remarketing. 
            Eventuali funzionalità di accesso riservato saranno ospitate su app.sportemocracy.it e non fanno parte di questo sito.
          </div>
        </section>

        <section class="legal-section">
          <h2>Categorie di cookie</h2>
          <div class="legal-table-wrapper">
            <table class="legal-table">
              <thead>
                <tr>
                  <th>Categoria</th>
                  <th>Dettagli</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Necessari</td>
                  <td>
                    Cookie di consenso del banner (Osano CookieConsent) per ricordare la scelta.
                    Nessun account o area riservata sul sito vetrina.
                  </td>
                </tr>
                <tr>
                  <td>Analitici</td>
                  <td>
                    Google Analytics 4 con cookie _ga e _ga_*, usati per statistiche aggregate e attivati
                    solo dopo il consenso esplicito.
                  </td>
                </tr>
                <tr>
                  <td>Marketing</td>
                  <td>Non utilizziamo cookie di marketing.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section class="legal-section">
          <h2>Gestire o revocare il consenso</h2>
          <div>
            Puoi rivedere la tua scelta tramite il link "Preferenze cookie" nel footer oppure dalle
            impostazioni del browser. Se disponibile, puoi anche riaprire il banner da
            <a
              v-if="canShowCookiePreferences"
              class="legal-link"
              href="#"
              @click.prevent="openCookiePreferences"
            ><strong>qui</strong></a><strong v-else>qui</strong>.
          </div>
        </section>

        <section class="legal-section">
          <h2>Trasferimenti e terze parti</h2>
          <div>
            I dati analytics sono trattati da Google come fornitore del servizio. Eventuali trasferimenti
            avvengono secondo i termini e le misure di sicurezza del provider.
          </div>
        </section>

        <section class="legal-section">
          <h2>Modifiche alla Cookie Policy</h2>
          <div>
            Potremmo aggiornare periodicamente questa Cookie Policy per riflettere modifiche normative, tecniche o operative. 
            In caso di aggiornamenti, la data di “Ultimo aggiornamento” indicata in cima alla pagina verrà modificata di conseguenza. 
            Ti invitiamo a consultare regolarmente questa pagina per rimanere informato su come utilizziamo i cookie.
          </div>
        </section>

        <section class="legal-section">
          <h2>Contatti</h2>
          <div>
            Per domande sulla Cookie Policy puoi scriverci a
            <a class="legal-link" href="mailto:info@sportemocracy.it">info@sportemocracy.it</a>.
          </div>
          <div>
            Consulta anche la
            <router-link class="legal-link" to="/legal/privacy">Privacy Policy</router-link>.
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '../../components/Header.vue';

export default {
  name: 'CookiePolicy',
  components: {
    Footer,
    Header
  },
  data() {
    return {
      canShowCookiePreferences: false
    };
  },
  mounted() {
    this.updateCookiePreferencesAvailability();
    if (typeof window !== 'undefined') {
      window.addEventListener('cookieconsentReady', this.updateCookiePreferencesAvailability);
    }
  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('cookieconsentReady', this.updateCookiePreferencesAvailability);
    }
  },
  methods: {
    updateCookiePreferencesAvailability() {
      if (typeof window === 'undefined') {
        this.canShowCookiePreferences = false;
        return;
      }
      var popup = window.__cookieconsentPopup;
      var hasPopup = popup && (typeof popup.open === 'function' || typeof popup.revokeChoice === 'function');
      var hasGlobal = window.cookieconsent && (typeof window.cookieconsent.open === 'function' || typeof window.cookieconsent.show === 'function');
      this.canShowCookiePreferences = Boolean(hasPopup || hasGlobal);
    },
    openCookiePreferences() {
      if (!this.canShowCookiePreferences || typeof window === 'undefined') {
        return;
      }
      var popup = window.__cookieconsentPopup;
      if (popup && typeof popup.open === 'function') {
        popup.open();
      } else if (popup && typeof popup.revokeChoice === 'function') {
        popup.revokeChoice();
      } else if (window.cookieconsent && typeof window.cookieconsent.open === 'function') {
        window.cookieconsent.open();
      } else if (window.cookieconsent && typeof window.cookieconsent.show === 'function') {
        window.cookieconsent.show(true);
      }
      var sync = window.__syncCookieBannerSpacing;
      if (typeof sync === 'function') {
        sync();
        setTimeout(sync, 50);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/colors.scss';

.legal-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: $neutral-light;
  color: $black;
  font-weight: 400;
  overflow-x: hidden;
  padding-top: var(--header-height);
}

.legal-content {
  flex: 1;
}

.legal-container {
  width: 100%;
  max-width: 920px;
  margin: 0 auto;
  padding: 2.5rem 1.5rem 4rem;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  box-sizing: border-box;
}

.legal-header {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.legal-title {
  font-size: 2.1rem;
  font-weight: 400;
  line-height: 1.1;
  margin: 0;
}

.legal-updated {
  font-size: 0.95rem;
  margin: 0;
  color: rgba($black, 0.6);
  font-weight: 400;
}

.legal-header div{
  font-size: 1rem;
  line-height: 1.7;
}

.legal-section {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba($black, 0.08);
}

.legal-section:first-of-type {
  border-top: none;
  padding-top: 0;
}

.legal-section h2 {
  font-size: 1.35rem;
  color: $black;
  font-weight: 400;
  margin: 0;
}

.legal-section div,
.legal-section li,
.legal-table th,
.legal-table td {
  font-size: 1rem;
  line-height: 1.7;
  overflow-wrap: anywhere;
}

.legal-section ul {
  margin: 0.75rem 0 0 1.25rem;
  padding: 0;
}

.legal-table-wrapper {
  overflow-x: auto;
  border-radius: 10px;
  border: 1px solid rgba($black, 0.08);
}

.legal-table {
  width: 100%;
  border-collapse: collapse;
  background: $neutral-light-alt;
  table-layout: fixed;
}

.legal-table th,
.legal-table td {
  padding: 0.8rem 0.9rem;
  border-bottom: 1px solid rgba($black, 0.08);
  text-align: left;
  vertical-align: top;
  font-size: 0.95rem;
}

.legal-table th {
  background: $neutral-light-alt;
  color: $black;
  font-weight: 400;
}

.legal-table tr:last-child td {
  border-bottom: none;
}

.legal-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.legal-link {
  color: $primary;
  text-decoration: underline;
}

.legal-link:hover {
  color: $secondary-warm;
}

@media (min-width: 900px) {
  .legal-container {
    padding: 3.5rem 2.5rem 4.5rem;
    gap: 2rem;
  }

  .legal-title {
    font-size: 2.6rem;
  }

  .legal-section h2 {
    font-size: 1.5rem;
  }
}
</style>
